import React from "react";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import ProjectHero from "./ProjectHero";

export default function ProjectModalContent({ project }) {
  return (
    <Sheet
      sx={{
        flex: 2,
        borderRadius: "24px",
        overflowY: { xs: "visible", sm: "visible", md: "scroll" },
      }}
    >
      <ProjectHero project={project} />
      <Typography
        id="modal-desc"
        textColor="text.tertiary"
        sx={{ px: 2, py: 1 }}
      >
        {project.description}
      </Typography>
    </Sheet>
  );
}
